import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ForBrands } from './pages/ForBrands';
import { ForMarketingAgencies } from './pages/ForMarketingAgencies';
import { ForTalent } from './pages/ForTalent';
import { CaseStudies } from './pages/CaseStudies';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="23w4ek0vqj40u">
      <ScrollToTop data-id="element-1" data-mp="23ujha3i1d6za" />
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-zano-pink/20" data-id="element-2" data-mp="23t8hsfvmildz">
        <Navbar data-id="element-3" data-mp="3ijpef4c7z5bc" />
        <main data-id="element-4" data-mp="3ii4q3wgi0ilx">
          <Routes data-id="element-5" data-mp="3mlayb9n68jv1">
            <Route path="/" element={<Home data-id="element-7" data-mp="3mjzsl4a6121a" />} data-id="element-6" data-mp="3mkrchhuehbbq" />
            <Route path="/for-brands" element={<ForBrands data-id="element-9" data-mp="3rbr9so7flver" />} data-id="element-8" data-mp="3mjg93j4va5l5" />
            <Route path="/for-marketing-agencies" element={<ForMarketingAgencies data-id="element-11" data-mp="6hq1ea16ddl" />} data-id="element-10" data-mp="3rdkhm6ts6loc" />
            <Route path="/for-talent" element={<ForTalent data-id="element-13" data-mp="2zld2xbxu5jcl" />} data-id="element-12" data-mp="56qxrrj5tst" />
            <Route path="/case-studies" element={<CaseStudies data-id="element-15" data-mp="2zn6actg9w7ln" />} data-id="element-14" data-mp="2zm4wkh7vh708" />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail data-id="element-17" data-mp="33ngfk3w8qtzg" />} data-id="element-16" data-mp="33mf2jtvnzxf3" />
            <Route path="/pricing" element={<Pricing data-id="element-19" data-mp="38l8gfnev5qfs" />} data-id="element-18" data-mp="33oi2b5mmd4x0" />
            <Route path="/login" element={<Login data-id="element-21" data-mp="38nunzn1r85y0" />} data-id="element-20" data-mp="38l053zye2t6p" />
            <Route path="/terms-of-service" element={<TermsOfService data-id="element-23" data-mp="3dlw9sfqkejd6" />} data-id="element-22" data-mp="3dkus3sf1mymh" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-25" data-mp="nw2ak1lu1ioz" />} data-id="element-24" data-mp="3dirwmsv4gdad" />
            <Route path="/cookie-policy" element={<CookiePolicy data-id="element-27" data-mp="nxwvhfx3tat2" />} data-id="element-26" data-mp="nur7y544igzg" />
          </Routes>
        </main>
        <Footer data-id="element-28" data-mp="st2heeqiaph5" />
      </div>
    </BrowserRouter>;
}